import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BusinessRuleUpsertModalComponent } from '@app/business-rules/components/business-rule-upsert-modal/business-rule-upsert-modal.component';
import { AuthService } from '@app/shared/services/auth.service';
import { ModalService } from '@app/shared/services/modal.service';
import { AddExistingSegmentsToSkillStandardsModalComponent } from '@app/skill-standards/components/modals/add-existing-segments-to-skill-standards-modal/add-existing-segments-to-skill-standards-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusinessRule, RuleTypes } from '@app/business-rules/model';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
@Component({
  selector: 'dgx-add-create-segments-to-skill-standards-modal',
  templateUrl: './add-create-segments-to-skill-standards-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCreateSegmentsToSkillStandardsModalComponent implements OnInit {
  public existingSegments: BusinessRule[] = [];
  public pendingSegments: BusinessRule[] = [];
  public saving: boolean = false;
  public orgId: number;
  public allowManageSegments: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private authService: AuthService,
    private modalService: ModalService
  ) {}

  public ngOnInit(): void {
    this.orgId = this.authService.authUser?.defaultOrgInfo?.organizationId;
    this.allowManageSegments =
      this.authService.authUser?.defaultOrgInfo?.permissions?.manageSegments;
    this.cycleModals();
  }

  /**
   * Cycles between the Add Segments and Create A Segment Modals, sharing info between each
   */
  public cycleModals() {
    this.openAddExistingSegmentsToSkillStandardsModal().subscribe(
      (result: {
        pendingSegments: BusinessRule[];
        createNewSegment: boolean;
      }) => {
        this.pendingSegments = result.pendingSegments;
        if (result.createNewSegment) {
          this.openCreateNewSegmentModal().subscribe(
            (result: BusinessRule) => {
              this.pendingSegments.push(result);
              this.cycleModals();
            },
            (err) => {
              // close the Create A Segment modal but re-open the Add Segments modal
              this.cycleModals();
            }
          );
        } else {
          this.activeModal.close(this.pendingSegments);
        }
      },
      (err) => {
        // if closing the Add Segments modal
        if (this.pendingSegments.length > 0){
          this.activeModal.close(this.pendingSegments);
        } else {
          this.activeModal.close();
        }
      }
    );
  }

  public openCreateNewSegmentModal() {
    return this.modalService.show(BusinessRuleUpsertModalComponent, {
      inputs: {
        orgId: this.orgId,
        initialRuleType: RuleTypes.Segment,
      },
      windowClass: 'xlg-modal',
      backdropClickClose: false,
      errorOnDismiss: true,
    });
  }

  public openAddExistingSegmentsToSkillStandardsModal() {
    return this.modalService
      .show(AddExistingSegmentsToSkillStandardsModalComponent, {
        inputs: {
          orgId: this.orgId,
          existingSegments: this.existingSegments,
          pendingSegments: this.pendingSegments,
          allowManageSegments: this.allowManageSegments,
        },
        backdropClickClose: false,
        errorOnDismiss: true,
      })
      .pipe(
        switchMap((results: any) => {
          return of(results);
        })
      );
  }
}
